import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Provider.css";
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import withMenuPermission from "../../../widgets/withMenuPermission";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';


const utils = new ViewUtils();

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to unit standard scope', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to uploaded documents', theme: true }
            ]
        }
    ]
};

const headCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme Code' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];

class OnlineProviderApprovalSkillsProgrammeScope extends Component {

    constructor(props) {
        super(props)

        this.state = {
            searchParameters: [{ Name: `OnlineProviderAppID`, Value: this.props.location.state.selection }],
            SPScope: null
        }
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineProviderApprovalDocuments',
                state: {
                    selection: this.props.location.state.selection,
                    QualScopeSelection: this.props.location.state.QualScopeSelection,
                    USScopeSelection: this.props.location.state.USScopeSelection,
                    SPScopeSelection: this.state.SPScope
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineProviderApprovalUnitStandardScope',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ SPScope: selection })
        }
        else {
            this.setState({ SPScope: null })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Provider Approval > Skills Programme Scope"}
                </p>
                <br></br>
                <EnhancedTable multiSelect={true} autoFetchData={true} headCells={headCells} searchParameters={this.state.searchParameters} paged={false}
                    dataUrl="api/sims/OnlineProviderApproval/GetSkillsProgrammeScope" onSelectionChange={this.handleSelectionChange}
                />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)} config={lowertoolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(OnlineProviderApprovalSkillsProgrammeScope));

